// import React, { createContext, useContext, useState } from "react";

// type ThemeContextType = {
//   darkMode: boolean;
//   toggleTheme: () => void;
// };

// const ThemeContext = createContext<ThemeContextType>({
//   darkMode: false,
//   toggleTheme: () => {},
// });

// export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [darkMode, setDarkMode] = useState(false);
//   const toggleTheme = () => setDarkMode(!darkMode);

//   return (
//     <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
//       <div className={darkMode ? "bg-dark text-light" : "bg-light text-dark"} style={{ minHeight: "100vh" }}>
//         {children}
//       </div>
//     </ThemeContext.Provider>
//   );
// };

// export const useTheme = () => useContext(ThemeContext);









// src/context/ThemeContext.tsx
import React, { createContext, useContext, useEffect, useLayoutEffect, useState } from "react";

interface ThemeContextProps {
  dark: boolean;
  toggle: () => void;
}

const ThemeContext = createContext<ThemeContextProps>({
  dark: false,
  toggle: () => {},
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dark, setDark] = useState<boolean>(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const toggle = () => {
    setDark((prev) => {
      const newMode = !prev;
      localStorage.setItem("theme", newMode ? "dark" : "light");
      return newMode;
    });
  };

  // Apply immediately when dark changes (runs before paint)
  useLayoutEffect(() => {
    document.body.classList.toggle("dark-mode", dark);
    document.documentElement.setAttribute("data-bs-theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
